'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _root = require('./root.html');

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  templateUrl: _root2.default
};


// WEBPACK FOOTER //
// ./root.component.js